import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TopicWall from './components/TopicWall';
import DigestSection from './components/DigestSection';
import PostGrid from './components/PostGrid';
import Timeline from './components/Timeline';
import ScreenshotGallery from './components/ScreenshotGallery';
import CommentsSection from './components/CommentsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TopicWall />
        <DigestSection />
        <PostGrid />
        <Timeline />
        <ScreenshotGallery />
        <CommentsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}